import { registerAction } from '../../Action'

const LOAD_FILTERS = 'LOAD_FILTERS'

const reducer = (state = {}, action) => ({
  ...state,
  filters: {
    ...state.filters,
    ...action.payload,
  },
})

const loadFilters = registerAction(LOAD_FILTERS, { reducer })

export default loadFilters
